<template>
  <div class="flex flex_col loggingpage">
    <!-- 上面的选择 -->
    <div class="selects">
      <el-form
        :model="queryParam"
        ref="ruleform"
        :inline="true"
        class="flex flex_ju_sb warnform-inline"
      >
        <div class="form-inputs">
          <el-form-item label="登录用户">
            <el-input
              v-model="queryParam.userName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="选择时间" class="form-picker">
            <div class="picker-divs picker-divs-more">
              <el-date-picker
                v-model="queryParam.startTime"
                size="small"
                type="datetime"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions0"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
              <i class="pick-icon-yuan el-icon-time"></i>
            </div>

            <span class="pick-word">至</span>
            <div class="picker-divs picker-divs-more">
              <el-date-picker
                v-model="queryParam.endTime"
                size="small"
                type="datetime"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
              <i class="pick-icon-yuan el-icon-time"></i>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="form-btns">
          <el-button type="primary" @click="searchClick">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下面的表格 -->
    <div class="warn-tables">
      <el-table
        v-loading="loading"
        :data="tableData"
        class="tables"
        :height="535"
        :stripe="true"
        align="center"
        header-cell-class-name="header-cell"
        cell-class-name="table-cell"
      >
        <el-table-column type="index" label="序号" width="150" align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="登录用户"
          width="180"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="module"
          label="执行模块"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="method"
          label="执行方法"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ip"
          label="IP地址"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column prop="content" label="参数说明" align="center" width="180" show-overflow-tooltip> -->
        <!-- </el-table-column> -->
        <!-- 占位数据 -->
        <div slot="empty" class="table-empty">
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无数据</div>
        </div>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        layout="prev, pager, next"
        :current-page.sync="ipagination.currentPage"
        :page-size="ipagination.pageSize"
        :total="ipagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * @description 日志记录页面
 */
import tableMinin from "@/mixins/TableMinin";
export default {
  mixins: [tableMinin],
  data() {
    const self = this;
    return {
      // 时间是否初始化默认赋值
      isMakeTime: false,
      ifUseLoadBack: false,
      isTranPage: true,
      tableEmpty: false,
      url: {
        list: self.$api.findLoggList,
      },
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },
  mounted() {
    this.$set(this.queryParam, "startTime", this.getNowDate() + " 00:00:00");
    this.$set(this.queryParam, "endTime", this.getNowDate() + " 23:59:59");
    setTimeout(() => {
      this.loadData(1);
    }, 100);
  },
  methods: {
    loadBack(res) {
      if (res.meta.success) {
        let result = res.data || {};
        if (result.total > 0) {
          this.tableEmpty = false;
          let datas = result.records || [];
          this.tableData = datas || [];
          this.ipagination.total = Number(result.total);
          this.ipagination.pageSize = Number(result.size);
        } else {
          this.tableEmpty = true;
          this.tableData = [];
          this.ipagination.total = 0;
          this.ipagination.pageSize = 10;
        }
      } else {
        this.tableEmpty = true;
        this.tableData = [];
        this.ipagination.total = 0;
        this.ipagination.pageSize = 10;
      }
    },
  },
};
</script>

<style lang="scss">
.loggingpage {
  height: 100%;
  // 时间选择框
  .warnform-inline {
    .form-picker {
      .picker-div {
        width: 3rem;
      }
    }
  }
  .warn-tables {
    padding-bottom: 0;

    flex: 1;
    min-height: 610px;
  }
}
</style>
